// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp, FaPhoneAlt, FaBars, FaTimes, FaMoon, FaSun } from 'react-icons/fa';
import '../styles/main.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/cars', label: 'Our Cars' },
    { path: '/tours', label: 'Tour Packages' },
    { path: '/contact', label: 'Contact' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle('menu-open', !isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const Logo = ({ mobile = false }) => (
    <div className={`logo ${mobile ? 'mobile-logo' : ''}`}>
      <div className="logo-container">
        <img 
          src="/whatsApp_DP.jpg" 
          alt="Mahalakshmi Cabs" 
          className="logo-icon-image"
        />
      </div>
      <div className="logo-text">
        <div className="logo-main">Mahalakshmi Cabs</div>
        <div className="logo-sub">Kodaikanal</div>
      </div>
    </div>
  );

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          {/* Logo */}
          <Link to="/" className="logo-link" onClick={closeMenu}>
            <Logo />
          </Link>

          {/* Spacer between Logo and Navigation */}
          <div className="nav-spacer"></div>

          {/* Desktop Navigation */}
          <div className="nav-links">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={closeMenu}
              >
                {item.label}
              </Link>
            ))}
          </div>

          {/* Spacer between Navigation and Actions */}
          <div className="nav-spacer"></div>

          {/* Desktop Actions */}
          <div className="header-actions">
            <button className="theme-toggle-btn" onClick={toggleTheme} aria-label="Toggle Theme">
              {theme === 'light' ? <FaMoon /> : <FaSun />}
            </button>
            <a href="tel:+918883377920" className="btn btn-call">
              <FaPhoneAlt /> Call Now
            </a>
            <a 
              href="https://wa.me/918883377920" 
              className="btn btn-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp /> Book Now
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu-backdrop ${isMenuOpen ? 'active' : ''}`} onClick={closeMenu}></div>
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <Link to="/" className="mobile-logo-link" onClick={closeMenu}>
            <Logo mobile={true} />
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button className="theme-toggle-btn" onClick={toggleTheme} aria-label="Toggle Theme">
              {theme === 'light' ? <FaMoon /> : <FaSun />}
            </button>
            <button className="mobile-close-btn" onClick={closeMenu}>
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="mobile-nav-links">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="mobile-contact-section">
          <h3>Contact Us</h3>
          <div className="mobile-buttons">
            <a 
              href="https://wa.me/918883377920" 
              className="btn btn-whatsapp btn-block"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              <FaWhatsapp /> WhatsApp
            </a>
            <a 
              href="tel:+918883377920" 
              className="btn btn-call btn-block"
              onClick={closeMenu}
            >
              <FaPhoneAlt /> Call Now
            </a>
          </div>
          <div className="mobile-contact-info">
            <p><strong>Primary:</strong> 88833 77920</p>
            <p><strong>Alternate:</strong> 84385 68508</p>
            <p>24/7 Service Available</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;